'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import { getComputedLayoutStyleDataToDesiredDomStateData } from 'ContentEditorUI/redux/selectors/styleSelectors';
import LayoutSectionStylesApplicator from 'InpageEditorUI/components/LayoutSectionStylesApplicator';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  layoutStyles: getComputedLayoutStyleDataToDesiredDomStateData(state)
});

/**
 * @param {Object} props.layoutStyles (optional)
 * @param {number} props.layoutSectionRenderCount (required)
 */
class LayoutSectionLayoutStyleContainer extends Component {
  render() {
    const {
      layoutStyles,
      layoutSectionRenderCount
    } = this.props;
    const layoutStyleApplicators = Object.keys(layoutStyles).map(nodeName => {
      return Object.keys(layoutStyles[nodeName]).map(domNodeSelector => {
        return /*#__PURE__*/_jsx(LayoutSectionStylesApplicator, {
          layoutSectionRenderCount: layoutSectionRenderCount,
          styles: layoutStyles[nodeName][domNodeSelector],
          domSelector: domNodeSelector
        }, domNodeSelector);
      });
    });
    return /*#__PURE__*/_jsx("div", {
      children: layoutStyleApplicators
    });
  }
}
export default connect(mapStateToProps)(LayoutSectionLayoutStyleContainer);